class ArticleContent {
  constructor() {
    this.$container = $(".js-article-content");
    if (!this.$container.length) return;

    this.first();
    this.last();
  }

  first() {
    this.$container.find("> *:first-child").addClass("first-child");
  }

  last() {
    this.$container.find("> *:last-child").addClass("last-child");
  }
}

export default ArticleContent;
